//#region types

import {
  Tファイル添付,
  T車輌分類,
  T車輌特種,
} from "../../../service/truck/TSyaryo"

/**
 * 車輌マスタ_車検証型定義
 */
export type TSyaryoMasterSyakenSyo = Partial<{
  自動車種別コード: string
  自動車用途コード: string
  陸運支局報告分類区分コード: string
  車体形状: string
  支払先ID: number
  メーカーコード: string | null
  メーカー車名: string | null
  車種詳細: string
  乗車定員: number
  最大積載量2: string
  最大積載量: number | null
  車輌重量: string
  車輌総重量: string
  車台番号: string
  長さ: number | null
  幅: number | null
  高さ: number | null
  シリアルNo: string
  車輌形式: string
  前前軸重: number | null
  前後軸重: number | null
  後前軸重: number | null
  後後軸重: number | null
  原動機型式: string
  所有者名称: string
  車検満了日: string
  使用者名称: string
  車輌営業所: string
}>

/**
 * 車両マスタ_基準緩和型定義
 */
export type TKijunKanwa = Partial<{
  基準緩和車輌: string
  基準緩和有効期限: string
  緩和書類制作会社: string
  緩和輸送依頼荷主: string
}>

/**
 * 車輌マスタ 架装情報 型定義
 */
export type TKasouJoho = Partial<{
  架装メーカー: string
  架装タンクNO: string
  台帳保管ファイル名: string
  備考１: string
  備考２: string
  任意保険加入フラグ: number
  火炎暴露保険フラグ: number
  保険NO: string
}>

/**
 * 車輌分類
 */
export type TSyaryoBunrui = T車輌分類 &
  Partial<{
    row_id?: string
  }>

export type TSyaryoBunruiTable = {
  車輌分類: TSyaryoBunrui[]
}

/**
 * 車輌特種
 */
export type TSyaryoTokusyu = T車輌特種 &
  Partial<{
    row_id?: string
  }>

export type TSyaryoTokusyuTable = {
  車輌特種: TSyaryoTokusyu[]
}

/**
 * 添付ファイル
 */
export type TFile = Tファイル添付 &
  Partial<{
    row_id?: string
  }>

export type TFileTable = {
  添付ファイルリスト: TFile[]
}

//#endregion

//#region

/**
 * 車輌マスタ_車検証 初期値
 */
export const initialSyakenSyoState: TSyaryoMasterSyakenSyo = {
  自動車種別コード: "",
  自動車用途コード: "",
  陸運支局報告分類区分コード: "",
  車体形状: "",
  メーカー車名: "",
  車種詳細: "",
  乗車定員: 0,
  最大積載量: null,
  最大積載量2: "",
  車輌重量: "",
  車輌総重量: "",
  車台番号: "",
  長さ: null,
  幅: null,
  高さ: null,
  シリアルNo: "",
  車輌形式: "",
  前前軸重: null,
  前後軸重: null,
  後前軸重: null,
  後後軸重: null,
  原動機型式: "",
  所有者名称: "",
  車検満了日: "",
  使用者名称: "",
  車輌営業所: "",
}

/**
 * 車両マスタ 基準緩和　初期値
 */
export const initialKijunKanwaState: TKijunKanwa = {
  基準緩和車輌: "",
  基準緩和有効期限: "", //new Date().toISOString(),
  緩和書類制作会社: "",
  緩和輸送依頼荷主: "",
}

export const initialKasouJohoState: TKasouJoho = {
  架装メーカー: "",
  架装タンクNO: "",
  台帳保管ファイル名: "",
  備考１: "",
  備考２: "",
  任意保険加入フラグ: 0,
  火炎暴露保険フラグ: 0,
  保険NO: "",
}

export const initialSyaryoBunruiTableState: TSyaryoBunruiTable = {
  車輌分類: [],
}

export const initialSyaryoTokusyuTableState: TSyaryoTokusyuTable = {
  車輌特種: [],
}

export const initialFileTableState: TFileTable = {
  添付ファイルリスト: [],
}

//#endregion
